<template>
  <div>
    <Layout></Layout>
    <!-- <simplert></simplert> -->
  </div>
</template>

<script>
import Layout from "./components/UILayout/Layout";

export default {
  name: "App",
  components: {
    Layout
  },
  data() {
    return {
      //
    };
  }
};
</script>

<style>

html {  
  overflow: -moz-scrollbars-none; 
  -ms-overflow-style: none;
}
html::-webkit-scrollbar { 
    width: 0 !important 
}

* {
  font-family: Century Gothic, Arial, sans-serif;
  color: #888;
  font-size: 2.3vh;
}

.v-toolbar__title {
    font-size: 2.6vh !important;
}

.v-toolbar__content {
  height: 5vh !important;
}

.center {
  text-align: center !important;
}

  .center div {
    width: auto !important;
    height: auto !important;
  }

.green {
  background-color: #7fc241 !important;
  border-color: #7fc241 !important;
}

.red {
  background-color: #ed4933 !important;
  border-color: #ed4933 !important;
}

.text-white {
  color: white !important;
}

/* .grecaptcha-badge {
  visibility: hidden;
} */
</style>
